import { useI18n } from '../i18n'
import styles from './RouteSkeleton.module.css'

/** Shown while the first route (a lazily loaded screen) is being fetched: a few ruled lines, no spinner. */
export function RouteSkeleton() {
  const { t } = useI18n()
  return (
    <div className={styles.skeleton} role="status" aria-busy="true">
      <span className="sr-only">{t('common.loading')}</span>
      <span className={styles.title} aria-hidden="true" />
      <span className={styles.line} aria-hidden="true" />
      <span className={styles.line} aria-hidden="true" />
      <span className={styles.line} aria-hidden="true" />
    </div>
  )
}
